export default function rebox (element) {
  $('.grid-content').rebox({selector: 'figure a'})
}
